import React, { useState } from 'react';
import styled from 'styled-components';
import { SelectedOption, SelectionTitle } from '../../../Styles';

const Wrapper = styled.div`
  margin-top: 35px;
  padding: 0 25px;

  .caster-legs-container {
    margin-top: 15px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 15px;
  }
`;

function CasterLegs({ casterLegId, casterLegs, productData, setProductVar }) {
  const [selected, setSelected] = useState(productData.casterLeg.name);
  const handleProductVar = casterLegId => {
    setProductVar({
      frame_id: productData.frame.id,
      //render property / value if the size is not null
      ...(productData.fabric && {
        fabric_id: productData.fabric.id
      }),
      ...(productData.frame.size !== null && {
        size_id: productData.frame.size.id
      }),
      ...(productData.frame.firmness && {
        firmness_id: productData.frame.firmness.id
      }),
      //render property / value if the leg is not null
      ...(productData.frame.orientation !== null && {
        orientation: productData.frame.orientation
      }),
      ...(productData.leg !== null && {
        leg_id: productData.leg.id
      }),
      ...(productData.constructionType && {
        construction_type_id: productData.constructionType.id
      }),
      //render property / value if the leg is not null
      ...(productData.frame.orientation !== null && {
        orientation: productData.frame.orientation
      }),
      ...(productData.frame.has_assembly_options && {
        is_assembled: productData.is_assembled
      }),
      ...(productData.frame.has_wallpaper_types && {
        wallpaper_type: productData.wallpaper_type
      }),
      ...(productData.frame.has_set_of_two && {
        supplier_quantity: productData.supplier_quantity
      }),
      caster_leg_id: casterLegId
    });
  };

  return (
    <Wrapper>
      <SelectionTitle>Caster Finish</SelectionTitle>
      <SelectedOption>{selected}</SelectedOption>
      <div className="caster-legs-container">
        {casterLegs.map(casterLegItem => {
          return (
            <CasterLegItem
              onClick={() => {
                handleProductVar(casterLegItem.id);
                setSelected(casterLegItem.name);
              }}
              className="caster-leg"
              key={casterLegItem.id}
              selected={casterLegId === casterLegItem.id}
            >
              <img
                src={casterLegItem.image}
                loading="lazy"
                alt={casterLegItem.name}
              />
            </CasterLegItem>
          );
        })}
      </div>
    </Wrapper>
  );
}

export default CasterLegs;

const CasterLegItem = styled.div`
  cursor: pointer;
  border: ${({ selected, theme }) =>
    selected ? `3px solid ${(theme.old ? '#2A5CAF' : theme.colors.french)}` : '1px solid white;'};
  img {
    width: 100%;
    height: auto;
  }
`;
